import gql from "graphql-tag";

export const LIST_RESPONSES_BY_ID = gql`
  query LIST_RESPONSES_BY_ID($id: String!) {
    nodeQuery(
      filter: {
        conditions: {
          field: "field_saying_association.entity.nid"
          value: [$id]
          operator: IN
        }
      }
    ) {
      entities {
        ... on NodeSayings {
          nid
          entityId
          title
          fieldSayingEmail
          fieldSayingRegion
          fieldSayingContext
          fieldSayingMeaning
          fieldSayingMediaUrl
          fieldMapCoordinateX
          fieldMapCoordinateY
          fieldSayingSourceUrl
          fieldSayingAssociation {
            targetId
          }
          fieldSayingSubmittedBy
        }
      }
    }
  }
`;
